export const EMAIL_REGEXP = new RegExp(
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
);

/**
 * Regular expression for matching years, including empty an string.
 */
export const YEAR_REGEXP = new RegExp(/^$|(?:(?:18|19|20|21)[0-9]{2}$)/);
